var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeshbekVid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3969 1.293C5.55938 1.87425 1.725 5.63363 1.02188 10.4899C0.909375 11.2493 0.909375 12.7493 1.02188 13.4993C1.74375 18.4774 5.69063 22.2368 10.6969 22.7336C14.0906 23.0711 17.55 21.693 19.7813 19.1336C20.5594 18.2336 21.2625 17.118 21.6656 16.1149L21.7969 15.7774L20.9719 14.9711C20.5125 14.5211 20.1281 14.1555 20.1 14.1555C20.0813 14.1555 19.9781 14.3993 19.875 14.7086C18.8156 18.0368 15.6281 20.4555 12.075 20.6149C9.58125 20.7274 7.2 19.7711 5.44688 17.943C3.90938 16.3305 3.09375 14.2774 3.09375 11.9993C3.09375 10.1993 3.55313 8.68988 4.5375 7.20863C5.79375 5.32425 7.7625 4.01175 10.0594 3.52425C10.5375 3.42113 10.7906 3.40238 11.7094 3.40238C12.9281 3.40238 13.4344 3.48675 14.4844 3.83363C16.5938 4.53675 18.525 6.243 19.4719 8.23988C19.8469 9.018 19.8844 8.92425 19.1063 9.19613C18.7313 9.32738 18.4219 9.44925 18.4125 9.468C18.3938 9.51488 22.0969 12.8149 22.1344 12.7774C22.1625 12.7493 22.3781 11.7086 22.4719 11.1555C22.5 10.9774 22.6406 10.1805 22.8 9.38363C22.95 8.57738 23.0719 7.90238 23.0719 7.86488C23.0719 7.818 22.875 7.86488 22.4719 8.01488C22.1438 8.13675 21.8531 8.21175 21.825 8.18363C21.8063 8.16488 21.7313 8.0055 21.6656 7.84613C21.6 7.68675 21.4219 7.30238 21.2625 7.00238C19.1531 3.00863 14.85 0.749251 10.3969 1.293Z",
    fill: "url(#paint0_linear_1815_5697)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0811 6.70195V7.3957L10.7529 7.48945C9.91855 7.72383 9.15918 8.2957 8.84981 8.92383C8.42793 9.80508 8.54981 10.8457 9.17793 11.5113C9.64668 12.027 10.1623 12.3082 11.4373 12.777C12.4217 13.1426 12.7779 13.4613 12.7779 13.9676C12.7873 14.3051 12.6654 14.502 12.3467 14.6801C11.7279 15.027 10.3967 14.9145 9.31856 14.427C9.12168 14.3332 8.95293 14.2676 8.95293 14.277C8.9248 14.3238 8.5498 15.8238 8.5498 15.9082C8.5498 16.0863 9.63731 16.4426 10.4998 16.5457L11.0248 16.6113V17.3051V17.9988H11.7279H12.4311V17.2582V16.4988L12.7967 16.4051C14.1748 16.0488 15.0279 15.0551 15.0373 13.7801C15.0467 12.777 14.6529 12.102 13.7436 11.5488C13.5561 11.4363 13.0404 11.202 12.5811 11.0238C11.5592 10.6207 11.2873 10.4707 11.0436 10.2082C10.8373 9.97383 10.7998 9.6832 10.9404 9.41133C11.2029 8.8957 12.4217 8.80195 13.5561 9.20508C14.2686 9.44883 14.1936 9.50508 14.4279 8.60508C14.5404 8.17383 14.6342 7.81758 14.6342 7.8082C14.6342 7.79883 14.5217 7.74258 14.3811 7.68633C14.0529 7.5457 13.3686 7.38633 12.8998 7.33945L12.5342 7.31133V6.66445V6.01758H11.8123H11.0811V6.70195Z",
    fill: "url(#paint1_linear_1815_5697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1815_5697",
    x1: 12.0047,
    y1: 1.21289,
    x2: 12.0047,
    y2: 22.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD957E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1815_5697",
    x1: 11.7936,
    y1: 6.01758,
    x2: 11.7936,
    y2: 17.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD957E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeshbekVid);
export default __webpack_public_path__ + "static/media/keshbek-vid.5905a080382b111ea6c9a384c559c8cc.svg";
export { ForwardRef as ReactComponent };